const paymentMethodLabels: Record<string, string> = {
  cash: "Cash",
  credit: "Credit Card",
  debit: "Debit",
  dutchie_pay: "Pay by Bank/DutchiePay",
};

export const getPaymentMethodsString = (paymentMethods: string[]) => {
  const sortedPaymentOptions = paymentMethods
    .map((method) => paymentMethodLabels[method])
    .sort((a, b) => a.localeCompare(b));

  return sortedPaymentOptions.join(", ");
};

export const fulfillmentCookieName = "userFulfillmentPreference";
